import React from 'react';

import PopularArticles from '../containers/PopularArticles';
import PromptContainer from '../containers/PromptContainer';
import TopicList from '../containers/TopicList';

const HomePage = () =>
  <div className="home-content-container">
    <PopularArticles />
    <div className="topic-list__grid">
      <TopicList />
    </div>
    <div className="prompt-container__grid">
      <PromptContainer />
    </div>
  </div>;

export default HomePage;
